/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Lines_InvalidInputs */

const en_error_linesheet_lines_invalid = /** @type {(inputs: Error_Linesheet_Lines_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some lines cannot be saved. Correct what is listed and save again.`)
};

/**
* | output |
* | --- |
* | "Some lines cannot be saved. Correct what is listed and save again." |
*
* @param {Error_Linesheet_Lines_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_lines_invalid = /** @type {((inputs?: Error_Linesheet_Lines_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Lines_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_lines_invalid(inputs)
});